import type { Periodicidad, PlanItem } from '../../../model/kartera-api-model'

export { errorMessage, money } from '../../customers/common/customer-common'

export const PLANS_PATH = '/planes'

export const PERIODICIDAD_LABELS: Record<Periodicidad, string> = {
    unico: 'Pago único',
    anual: 'Anual',
    mensual: 'Mensual',
    prueba: 'Periodo de prueba',
}

export const PRICE_SUFFIX: Partial<Record<Periodicidad, string>> = {
    anual: '/ año',
    mensual: '/ mes',
}

export interface PlanFeature {
    id: string
    label: string
    value: string
    help: string | null
}

export const planFeature = (item: PlanItem, index: number): PlanFeature => ({
    id: String(item.id ?? index),
    label: item.descripcion || item.nombre || '—',
    value: item.cantidad == null ? '' : `${item.cantidad}${item.nombre === 'Frecuencia' ? ' días' : ''}`,
    help: item.ayuda || null,
})
